import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { MineralizationProps } from 'utils/types';

export const fileKey = ['fileMineralization'];

const useCroptimizerMineralization = () => useQuery({
  queryKey: [fileKey, 'croptimizer'],
  queryFn: () => agent.getClient()('file-data/croptimizer?tag=mineralization').then(
    (response) => {
      const result: MineralizationProps[] = [];
      response?.data?.data?.forEach((element: any) => {
        result.push({
          ['Country']: element?.['0'],
          ['NRate']: element?.['1'],
          ['P2O5Rate']: element?.['2'],
          ['SO3Rate']: element?.['3'],
          ['NPrice']: element?.['4'],
          ['P2O5Price']: element?.['5'],
          ['K2OPrice']: element?.['6'],
          ['SO3Price']: element?.['7'],
        });
      });

      return result as MineralizationProps[];
    },
  ),
  staleTime: 5 * 60 * 1000,
  gcTime: 10 * 60 * 1000,
});

export default useCroptimizerMineralization;
